import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CacheService } from '../../services/cache/cache.service';
import { PushNotification, PushNotificationsResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class PushNotificationsDataService {

  private uri: string = `${environment.apiUrl}push-notifications`;
  private cacheKey: string = 'pushNotifications.cache';

  constructor(
    private http: HttpClient,
    private cache: CacheService,
  ) {

  }

  getPushNotification(id: number): Observable<PushNotification|any> {
    return this.http.get(this.uri + `/${id}`);
  }

  getPushNotifications(parameters: {[param: string]: string | string[]}): Observable<PushNotificationsResult|any> {
    return this.http.get(this.uri, {params: parameters});
  }

  addPushNotification(data: PushNotification): Observable<PushNotification|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.post(this.uri, cleanData);
  }

  addPushNotifications(data: PushNotification[]): Observable<PushNotification[]|any> {
    this.clearCache();
    return this.http.post(this.uri + `/bulk`, data);
  }

  updatePushNotification(data: PushNotification): Observable<PushNotification|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.put(this.uri + `/${data.id}`, cleanData);
  }

  updatePushNotifications(data: PushNotification[]): Observable<PushNotification[]|any> {
    this.clearCache();
    return this.http.put(this.uri + `/bulk`, data);
  }

  patchPushNotification(data: PushNotification): Observable<PushNotification|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.patch(this.uri + `/${data.id}`, cleanData);
  }

  patchPushNotifications(data: PushNotification[]): Observable<PushNotification[]|any> {
    this.clearCache();
    return this.http.patch(this.uri + `/bulk`, data);
  }

  deletePushNotification(data: PushNotification): Observable<null|any> {
    this.clearCache();
    return this.http.delete(this.uri + `/${data.id}`);
  }

  deletePushNotifications(data: PushNotification[]): Observable<null|any> {
    this.clearCache();
    const params: {ids: string} = {ids: ''};
    const ids: string[] = [];
    data.forEach((pushNotification) => {
      ids.push(pushNotification.id + '');
    });
    params.ids = ids.join(',');
    return this.http.delete(this.uri + `/bulk`, {params: params});
  }

  clearCache(): void {
    this.cache.remove(this.cacheKey);
  }

}
